import { CardWrapper } from "Components/Common/Card/index";
import { Hr } from "Components/Common/Hr/index";
import { Spacer } from "Components/Common/Spacer/index";
import { TypographyT56 } from "Components/Common/Typography/index";
import React, { Fragment } from "react";
import CargoDetails from "./CargoDetails";
import CargoDescription from "./CargoDescription";
import SelectT1 from "Components/Common/Select/SelectT1";
import { LabelT6 } from "Components/Common/Label/index";
import { Wrapper } from "Components/Common/Wrapper/index";
import HandlingInstructions from "./HandlingInstructions";

const options = [
  { value: "supplier 01", label: "supplier 01" },
  { value: "supplier 02", label: "supplier 02" },
  { value: "supplier 03", label: "supplier 03" },
  { value: "supplier 04", label: "supplier 04" },
  { value: "supplier 05", label: "supplier 05" },
];

const CardT2 = (props) => {
  const {
    cargoDetailsTypesList,
    cargo_details,
    handleToggleCargoDetails,
    handleDownloadCargoMaterialPackingTemaplateFile,
    handleOnChangeForCargoMaterialPackingTemplateFile,
    material_packing_list,
    handleOnClickForAddMaterialPackingBtn,
    handleOnClickForRemoveMaterialPackingBtn,
    handleOnChangeForMaterialPackingInputs,
    handlingInstructionTypesList,
    handling_instructions,
    handleToggleHandlingInstructions,
    packingTypesList,
    selectedPackagingType,
    handleOnChangeForPackagingType,
    isTemperatureCardShown,
    handleCloseTemperatureCard,
    temperatureDetails,
    handleSaveTemperatureDetails,
    
  } = props;
  return (
    <Fragment>
      <CardWrapper>
        <TypographyT56>Cargo Information</TypographyT56>
        <Hr />
        <Spacer spacing={"10px"} />
        <CargoDetails
          cargoDetailsTypesList={cargoDetailsTypesList}
          cargo_details={cargo_details}
          handleToggleCargoDetails={handleToggleCargoDetails}
        />
        <Spacer spacing={"10px"} />
        <CargoDescription
          handleDownloadCargoMaterialPackingTemaplateFile={
            handleDownloadCargoMaterialPackingTemaplateFile
          }
          handleOnChangeForCargoMaterialPackingTemplateFile={
            handleOnChangeForCargoMaterialPackingTemplateFile
          }
          material_packing_list={material_packing_list}
          handleOnClickForAddMaterialPackingBtn={
            handleOnClickForAddMaterialPackingBtn
          }
          handleOnClickForRemoveMaterialPackingBtn={
            handleOnClickForRemoveMaterialPackingBtn
          }
          handleOnChangeForMaterialPackingInputs={
            handleOnChangeForMaterialPackingInputs
          }
          packingTypesList={packingTypesList}
        />
        <Spacer spacing={"10px"} />
        {/* <Wrapper style={{ width: "fit-content" }}>
          <LabelT6>Packaging Type</LabelT6>
          <Spacer spacing={"3px"} />
          <SelectT1
            placeholder={"Select"}
            isClearable={true}
            options={packingTypesList}
            isSearchable={true}
            value={selectedPackagingType}
            onChange={handleOnChangeForPackagingType}
          />
        </Wrapper>
        <Spacer spacing={"10px"} /> */}
        <HandlingInstructions
          handlingInstructionTypesList={handlingInstructionTypesList}
          handling_instructions={handling_instructions}
          handleToggleHandlingInstructions={handleToggleHandlingInstructions}
          isTemperatureCardShown = {isTemperatureCardShown}
          handleCloseTemperatureCard = {handleCloseTemperatureCard}
          temperatureDetails = {temperatureDetails}
          handleSaveTemperatureDetails = {handleSaveTemperatureDetails}
        />
      </CardWrapper>
    </Fragment>
  );
};

export default CardT2;
